export const PRIVACY_POLICY_PATH = '/polityka-prywatnosci';
export const PRIVACY_POLICY_PAGE_URL = 'https://universemapmaker.online/polityka-prywatnosci';
export const ACCOUNT_DELETION_ANCHOR = 'usuniecie-konta';
export const PRIVACY_CONTACT_EMAIL = 'contact@mapmaker.online';
